import {createAction} from "@reduxjs/toolkit";

import {
  DONE,
  FAIL,
  FETCH, SET, FORM, GET, CTP, PERIOD, EXTRA, FILTER, GROUPS, RESET, COMMON,
} from "../constants";
import {IFormType, ISendFormType} from "./types";

export const getFormAction = createAction<IFormType>(GET + FORM + FETCH);
export const getFormActionDone = createAction<IFormType>(GET + FORM + FETCH + DONE);
export const getFormActionFail = createAction<IFormType>(GET + FORM + FETCH + FAIL);
export const getFormActionReset = createAction<undefined>(GET + FORM + FETCH + RESET);

export const setFormAction = createAction<ISendFormType>(SET + FORM + FETCH);
export const setFormActionDone = createAction<ISendFormType>(SET + FORM + FETCH + DONE);
export const setFormActionFail = createAction<any>(SET + FORM + FETCH + FAIL);
export const setFormActionReset = createAction<undefined>(SET + FORM + FETCH + RESET);

export const getCtpAction = createAction<any>(GET + CTP + FETCH);
export const getCtpActionDone = createAction<any>(GET + CTP + FETCH + DONE);
export const getCtpActionFail = createAction<undefined>(GET + CTP + FETCH + FAIL);

export const getCtpFilterAction = createAction<any>(GET + CTP + FILTER + FETCH);
export const getCtpFilterActionDone = createAction<any>(GET + CTP + FILTER + FETCH + DONE);
export const getCtpFilterActionFail = createAction<undefined>(GET + CTP + FILTER + FETCH + FAIL);

export const getPeriodAction = createAction<any>(GET + PERIOD + FETCH);
export const getPeriodActionDone = createAction<any>(GET + PERIOD + FETCH + DONE);
export const getPeriodActionFail = createAction<undefined>(GET + PERIOD + FETCH + FAIL);

export const getFormExtraAction = createAction<any>(GET + FORM + EXTRA + FETCH);
export const getFormExtraActionDone = createAction<any>(GET + FORM + EXTRA + FETCH + DONE);
export const getFormExtraActionFail = createAction<any>(GET + FORM + EXTRA + FETCH + FAIL);

export const resetCommon = createAction<undefined>(RESET + COMMON);